import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { getNewId } from '../../actions/home.actions';
import { LookaheadTag, LookaheadTagStatus } from '../../models/LookaheadTag';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Trade } from '../../models/Trade';
import classNames from 'classnames';
import { ColumnType } from '../PhasePlan/Column';
import { Constraint, ConstraintStatus } from '../../models/Constraint';
import moment, { Moment } from 'moment'
import { DatePicker } from "material-ui-pickers";


const _ = require('lodash')

interface IFormConstraint {
    dateCreated: number;
    identifyBy: string;
    assignedTo?: string;
    description?: string;
    dueByDate: number;
    tagId?: string;
    status: ConstraintStatus;
}

interface Props {
    constraintToEdit: Constraint,
    isConstraintDialogOpen: boolean,
    constraintToEditId: string,
    isLookaheadTagDialogOpen: boolean,
    classes: ClassNameMap;
    closeDialogValue: () => Promise<void>;
    tagSelectList: Record<string, string>;
    trades: Record<string, Trade>;
    submitValue: (type: ColumnType, constraint: Constraint, constraintId?: string) => Promise<void>;
    errorAlert: (message:string) => Promise<void>;
    projectUsers: Record<string, any>;
    type: ColumnType

}

type State = {
    constraint: IFormConstraint
    constraintId?: string | null,
    status: LookaheadTagStatus
}



class ConstraintDialog extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            constraintId: null,
            constraint: {
                dateCreated: moment().valueOf(),
                identifyBy: "",
                description: "",
                dueByDate: moment().valueOf(),
                tagId: null,
                tagType: null,
                assignedTo: null,
                status: ConstraintStatus.Todo
            }
        }
    }

    componentDidMount() {
        const {
            constraintToEdit,
            constraintToEditId
          } = this.props;
          if(!!constraintToEdit) {
            this.state = {
              constraintId: constraintToEditId,
              constraint: {
                dateCreated: !!constraintToEdit.dateCreated ? constraintToEdit.dateCreated : moment().valueOf(),
                identifyBy: constraintToEdit.identifyBy,
                assignedTo: constraintToEdit.assignedTo,
                description: constraintToEdit.description,
                dueByDate: !!constraintToEdit.dateCreated ? constraintToEdit.dateCreated : moment().valueOf(),
                tagId: constraintToEdit.tagId,
                tagType: constraintToEdit.tagType,
                status: constraintToEdit.status
              }
            }
          }
    }

    shouldComponentUpdate(nextProps: Props, nextState: State) {

        if (!nextProps.constraintToEditId && !!this.props.constraintToEditId) {
        
            nextState.constraint = {
                dateCreated: moment().valueOf(),
                identifyBy: "",
                assignedTo: "",
                description: "",
                dueByDate: moment().valueOf(),
                tagId: null,
                tagType: null,
                status: ConstraintStatus.Todo
            }
        
        }

        if(!!nextProps.constraintToEdit && !_.isEqual(nextProps.constraintToEditId, this.props.constraintToEditId)) {

            nextState.constraint = nextProps.constraintToEdit
            if(!!nextState.constraint && !nextState.constraint.status) {
                nextState.constraint.status = ConstraintStatus.Todo
            }
            return true
        }
    
        
    
        if(!_.isEqual(nextState.constraint, this.state.constraint))  {
            return true
        }

        if(this.props.isConstraintDialogOpen !== nextProps.isConstraintDialogOpen) {
            nextState.constraint = {
                dateCreated: moment().valueOf(),
                identifyBy: "",
                assignedTo: "",
                description: "",
                dueByDate: moment().valueOf(),
                tagId: null,
                tagType: null,
                status: ConstraintStatus.Todo
            }
            return true
        }

        if(!_.isEqual(this.props.tagSelectList, nextProps.tagSelectList)) {
            return true
        }
    
    
        return false
    }

    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onTagChanged = (value: any) => {
        const constraint = { ...this.state.constraint }
        constraint.tagId = value.value
        constraint.tagType = ColumnType.PhasePlan

        this.setState({
            constraint
        });
    }  

    onDescriptionChange = async (event: any) => {
        const constraint = { ...this.state.constraint }
        constraint.description = event.target.value
        this.setState({
            constraint
        });
    }




    onSubmit = async() => {
        const { constraint } = this.state
        const { submitValue, errorAlert, constraintToEditId, type } = this.props

        if(!constraint.dateCreated || !constraint.identifyBy || !constraint.status) {
            errorAlert('Fill Required Fields')
            return 
        }

        submitValue(type, constraint, constraintToEditId)
        this.closeDialog()
    }

    

    getConstraintStatusList = () => {
        return Object.entries(ConstraintStatus).map(([key,value]) => {
            return {
                uid: key,
                name: value
            }
        })
    }

    onStatusChanged = (value: any) => {
        const constraint = { ...this.state.constraint }
        constraint.status = value.value
        this.setState({
            constraint
        })
    }

    onIdentifyBy = async (value: any) => {
        const constraint = { ...this.state.constraint }
        constraint.identifyBy = value.value

        this.setState({
            constraint
        });   
    }

    onAssignedTo = async (value: any) => {
        const constraint = { ...this.state.constraint }
        constraint.assignedTo = value.value

        this.setState({
            constraint
        });   
    }


    onDateCreatedChange = async (value: Moment) => {
        const constraint = { ...this.state.constraint }
    
        constraint.dateCreated = value.valueOf()
        this.setState({
            constraint
        })
    }

    onDueDateChange = async (value: Moment) => {
        const constraint = { ...this.state.constraint }
    
        constraint.dueByDate = value.valueOf()
        this.setState({
            constraint
        })
    }

    render() {
        const { isConstraintDialogOpen, classes, tagSelectList } = this.props;
        const { constraint } = this.state

        return (
          <Dialog
            maxWidth='sm'
            fullWidth={true}
            open={!!isConstraintDialogOpen}
            onBackdropClick={this.closeDialog}
          >
              <DialogContent>
              <div className={classNames(classes.DialogFormTitle, classes.DialogFormHelpInfoTitle)}>
                    <p className={classes.DialogFormTitleText}>
                        Constraint
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Date Identified*</p>
                        <DatePicker fullWidth={true} value={moment(constraint.dateCreated)} onChange={this.onDateCreatedChange} label="" />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Identified By</p>
                        <SelectList
                            isMulti={false}
                            title=''
                            onChange={this.onIdentifyBy}
                            optionList={this.props.projectUsers}
                            value={constraint.identifyBy} />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Assigned To</p>
                        <SelectList
                            isMulti={false}
                            title=''
                            onChange={this.onAssignedTo}
                            optionList={this.props.projectUsers}
                            value={constraint.assignedTo} />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Status</p>

                        <SelectList
                            onChange={this.onStatusChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.getConstraintStatusList()}
                            value={constraint.status}
                        />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Tag Constrained</p>

                        <SelectList
                            onChange={this.onTagChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.props.tagSelectList}
                            value={constraint.tagId}
                        />
                    </div>
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Description</p>
                        <TextField
                            onChange={this.onDescriptionChange}
                            required
                            defaultValue={constraint.description}
                            fullWidth={true}
                        />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Due Date</p>

                        <DatePicker fullWidth={true} value={moment(constraint.dueByDate)} onChange={this.onDueDateChange} label="" />
                    </div>
                    

                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                <Button onClick={this.onSubmit.bind(this)}  color="primary"> Confirm </Button>
              </DialogActions>
          </Dialog>
        )
    }
    
}


export default ConstraintDialog
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/ConstraintDialog.tsx